export default function CsharpTypeCasting() {
  return (
    <h2>Csharp Type Casting</h2>
  );
}
